import {
  ALL_LICENSE_STATUSES,
  type AppLicenseStatus,
} from "@/lib/enum-constants";
import z from "zod";

export const LicenseInfoSchema = z.object({
  status: z.enum(
    ALL_LICENSE_STATUSES as unknown as [
      AppLicenseStatus,
      ...AppLicenseStatus[],
    ],
  ),
  renewal_date: z.string().nullable(),
  effective_date: z.string().min(1, "This field is required"),
  effective_end_date: z.string().nullable(),
  approved_at: z.string().nullable(),
  approved_until_date: z.string().nullable(),
  cancellation_date: z.string().nullable(),
  cancellation_reason: z.string({ message: "Not valid text" }).nullable(),
});

export const PropertySchema = z.object({
  address1: z.string().min(1, "This field is required"),
  address2: z.string({ message: "Not valid text" }).nullable(),
  city: z.string().min(1, "This field is required"),
  state: z.string().min(1, "This field is required"),
  zipcode: z.string().min(1, "This field is required"),
  apn: z.string({ message: "Not valid text" }).nullable(),
});

export const PersonSchema = z.object({
  name: z.string().min(1, "This field is required"),
  email: z.preprocess(
    (val) => (val === "" ? null : val),
    z.string().email({ message: "Invalid email address" }).nullable(),
  ) as unknown as z.ZodNullable<z.ZodString>,
  phone: z.string({ message: "Not valid text" }).nullable(),
  address1: z.string({ message: "Not valid text" }).nullable(),
  address2: z.string({ message: "Not valid text" }).nullable(),
  city: z.string({ message: "Not valid text" }).nullable(),
  state: z.string({ message: "Not valid text" }).nullable(),
  zipcode: z.string({ message: "Not valid text" }).nullable(),
});
